module.exports = __webpack_public_path__ + "static/media/main.56d433ae.png";